import { createContext, useContext, type ReactNode } from 'react';

/**
 * 🔒 Decision 7620 (T3124): whether the viewer holds the super admin role, from
 * the frame's own answer. The Storage block on a file's details, the stored-objects
 * card on Storage and Backups and Inspect in a record's banner menu read it and
 * draw nothing for anybody else; the routes behind them refuse anybody else
 * whatever the page draws. 💰 Outside the frame it reads false, so a screen drawn
 * alone in a suite shows none of the three unless the suite says otherwise.
 */
const SuperAdminContext = createContext<boolean>(false);

export function SuperAdminProvider({ superAdmin, children }: { superAdmin: boolean; children: ReactNode }) {
  return <SuperAdminContext.Provider value={superAdmin}>{children}</SuperAdminContext.Provider>;
}

export function useSuperAdmin(): boolean {
  return useContext(SuperAdminContext);
}
